module.exports = __webpack_public_path__ + "assets/img/044.a38bebf7.png";